import { render, staticRenderFns } from "./receipt-table.vue?vue&type=template&id=6bc858fd&scoped=true"
import script from "./receipt-table.vue?vue&type=script&lang=js"
export * from "./receipt-table.vue?vue&type=script&lang=js"
import style0 from "./receipt-table.vue?vue&type=style&index=0&id=6bc858fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc858fd",
  null
  
)

export default component.exports